"use client";

import React from "react";
import { Menu } from "react-feather";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LocationDisplay from "../components/home_components/Locations";
import { isAuthenticated } from "../utils/helpers";
import { GetProfile } from "../services/profile";

const MobileHeader = React.forwardRef(({ onMenuClick, menu = false }, ref) => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  // Fetch user profile data for avatar
  useEffect(() => {
    async function fetchProfile() {
      if (isAuthenticated()) {
        try {
          const profile = await GetProfile();
          setUserData(profile.data);
        } catch (error) {
          console.error("Error fetching profile:", error);
          // Don't show error toast in header, just fail silently
        }
      }
    }
    fetchProfile();
  }, []);

  const handleProfileClick = () => {
    if (!isAuthenticated()) {
      localStorage.setItem("target", "/profile");
      navigate("/signin");
      return;
    } else {
      navigate("/profile");
    }
  };

  return (
    <header ref={ref} className="top-0 left-0 right-0 z-30 border-b">
      <div className="flex items-center justify-between p-4 pb-1">
        {/* Left side - Menu button + Logo and Location */}
        <div className="flex items-start pl-2">
          {menu && (
            <button
              className="bg-none border-none cursor-pointer mr-3"
              onClick={onMenuClick}
            >
              <Menu size={24} />
            </button>
          )}

          <div className="pb-0">
            <div className="flex items-center">
              <img
                src="/images/ping-desi-logo.png"
                alt="Gallyo logo"
                width={20}
                height={20}
                className="object-contain mr-2"
              />
              <div className="font-semibold text-[#7B189F]">Gallyo</div>
            </div>
            <div className="text-sm text-gray-700 pl-7 mt-1">
              <LocationDisplay />
            </div>
          </div>
        </div>

        {/* Right side - Profile Avatar */}
        <div className="flex items-center pr-2">
          <button
            onClick={handleProfileClick}
            className="w-8 h-8 rounded-full overflow-hidden border-2 border-[#7B189F] hover:border-purple-700 transition-colors cursor-pointer bg-pink-100"
            title="Profile"
          >
            <img
              src={
                userData?.profileImage ||
                userData?.avatarurl ||
                "/placeholder.svg"
              }
              alt="Profile Avatar"
              className="w-full h-full object-cover"
            />
          </button>
        </div>
      </div>
    </header>
  );
});

MobileHeader.displayName = "MobileHeader";

export default MobileHeader;
